// @ts-strict-ignore
import { StyledTextProps, allStyledSystemFunctions } from './config'
import { breakpoints } from '@gassan-ui'
import shouldForwardProp from '@styled-system/should-forward-prop'
import { rem } from 'polished'
import React, { FC } from 'react'
import styled, { css } from 'styled-components'

const headingBase = css`
  text-transform: uppercase;
  font-family: Helvetica, sans-serif;
  text-rendering: optimizeLegibility;
  line-height: 1.3;
  font-weight: bold;
  color: ${(p) => p.theme.rolex.colors.shades[900]};
`
const largeTitle = css`
  ${headingBase};
  font-weight: 400;
  font-size: 1.5rem;
  letter-spacing: 0.1875rem;
  @media screen and (min-width: ${breakpoints.medium}) {
    font-size: ${rem(38)};
  }
`
const mediumTitle = css`
  ${headingBase};
  font-size: 1.5rem;
  @media screen and (min-width: ${breakpoints.medium}) {
    font-size: 1.75rem;
  }
`
const pushTitle = css`
  ${headingBase};
  font-size: 1rem;
  @media screen and (min-width: ${breakpoints.medium}) {
    font-size: ${rem(18)};
  }
`
const gridTitle = css`
  ${headingBase};
  font-size: ${rem(13)};
  letter-spacing: 0.1875rem;
  @media screen and (min-width: ${breakpoints.medium}) {
    font-size: ${rem(18)};
  }
`
const smallSubtitle = css`
  ${headingBase};
  font-size: ${rem(9)};
  font-weight: 300;
`
const smallTitle = css`
  ${headingBase};
  font-size: ${rem(11)};
  @media screen and (min-width: ${breakpoints.medium}) {
    font-size: ${rem(14)};
  }
`
const verySmallTitle = css`
  ${headingBase};
  text-transform: none;
  font-size: ${rem(14)};
  @media screen and (min-width: ${breakpoints.medium}) {
    font-size: 1rem;
  }
`
const subtitle = css`
  ${headingBase};
  text-transform: none;
  font-size: ${rem(11)};
  @media screen and (min-width: ${breakpoints.medium}) {
    font-size: ${rem(13)};
  }
`

const headingStyles = {
  largeTitle,
  mediumTitle,
  pushTitle,
  gridTitle,
  smallSubtitle,
  smallTitle,
  verySmallTitle,
  subtitle,
}
type HeadingProps = React.HTMLAttributes<HTMLElement> &
  StyledTextProps & {
    variant: keyof typeof headingStyles
  }

export const Heading: FC<HeadingProps> = styled<React.FC<HeadingProps>>((props: HeadingProps) => (
  <div {...props} />
)).withConfig({ shouldForwardProp })<HeadingProps>`
  ${(p) => headingStyles[p.variant]};
  ${allStyledSystemFunctions};
`

Heading.defaultProps = {
  mb: 2,
}
